<template>
  <v-dialog max-width="480" v-model="dialog" persistent outlined>
    <v-card class="text-center">
      <v-card-title class="justify-center">
        <v-icon color="warning" size="86">mdi-alert-circle</v-icon>
      </v-card-title>
      <v-card-title class="headline justify-center">
        <span style="word-break: normal">{{
          $translate('E_ORD_001_FAILED_PRODUCTS')
        }}</span>
      </v-card-title>
      <section v-for="(name, index) in failedProductsName" :key="index">
        <v-card-text class="ma-0 pa-0">
          <span class="text-h6">
            <v-icon>mdi-arrow-right-bold</v-icon>{{ name }}</span
          >
        </v-card-text>
      </section>
      <v-row class="ma-0 pa-2">
        <span> {{ $translate('FAILED_PRODUCT_DESC') }} </span>
      </v-row>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          block
          large
          color="primary"
          class="mt-3 primary-font-color"
          @click="onCancel()"
        >
          {{ $translate('CLOSE') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'FailedProductsDialog',
  props: {
    dialog: Boolean,
    items: {
      type: Array,
      default: () => [],
    },
  },
  computed: {},
  mounted() {
    this.init();
  },
  watch: {
    items() {
      this.init();
    },
  },
  data() {
    return {
      failedProducts: [],
      failedProductsName: [],
    };
  },
  methods: {
    init() {
      this.failedProducts = this.items;
      if (this.failedProducts.length > 0) {
        this.failedProductsName = [];
        this.failedProducts.forEach((product) => {
          this.failedProductsName.push(product.Name);
        });
      }
    },
    onCancel() {
      this.$emit('cancel');
    },
  },
};
</script>
